import GroupDetailDialog from '../GroupDetailDialog.vue';

export default {
    components: { GroupDetailDialog },
    data() {
        return {
            groupDetailDialog: {
                isInsert: false,
                index: -1,
                visible: false,
                purpose: null,
                data: null,
                isTop: undefined,
            },
            incomeStateRelation: [
                {
                    category: 'invoiceSettings', // 營業收入
                    canUseTypes: [4], // 4.營業收入
                },
                {
                    category: 'payoutSettings', // 營業支出
                    canUseTypes: [5, 6], // 5.營業成本 | 6.營業費用
                },
                {
                    category: 'cInSettings', // 營業其他收入
                    canUseTypes: [7], // 7.營業外收入
                },
                {
                    category: 'cOutSettings', // 營業其他支出
                    canUseTypes: [6, 8], // 8.營業外支出
                },
            ],
        };
    },
    methods: {
        onGroupDialogAdd(data) {
            const DATA = {
                grP_MEM: data.grP_MEM,
                iteM_NAM: data.iteM_NAM,
                grP_NAM: data.grP_NAM,
                grP_AMT: data.grP_AMT,
                isshare: data.isshare,
                childSettings: [],
            };

            if (this.groupDetailDialog.isInsert) this.groupItemSetting[this.activeCategory].splice(0, 0, DATA);
            else this.groupItemSetting[this.activeCategory].push(DATA);

            this.onSave();
        },
        onGroupDialogUpdate(data) {
            const FOUND = this.groupItemSetting[this.activeCategory][this.groupDetailDialog.index];

            FOUND.grP_MEM = data.grP_MEM;
            FOUND.iteM_NAM = data.iteM_NAM;
            FOUND.grP_NAM = data.grP_NAM;
            FOUND.grP_AMT = data.grP_AMT;
            FOUND.isshare = data.isshare;
            this.activeGroupName = FOUND.iteM_NAM;
            this.onSave();
        },
        onGroupDialogDelete() {
            this.groupItemSetting[this.activeCategory].splice(this.groupDetailDialog.index, 1);
            this.activeGroupName = null;
            this.onSave();
        },
        onGroupDialogClose() {
            this.groupDetailDialog.visible = false;
        },
        isIncomeOptionUsable(incomeStateId) {
            const cate = this.incomeStateRelation.find((x) => x.category === this.activeCategory);
            return cate.canUseTypes.includes(incomeStateId);
        },
    },
};
